import * as React from 'react';
import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { PromosWrapper, ArrowControls, PromoCarousel, Banner } from '../../components/Promos';
import { getMortgageBanner } from '../../selectors';

export function Promos() {
  const navRef = {
    next: React.useRef<HTMLButtonElement>(null),
    prev: React.useRef<HTMLButtonElement>(null),
  };

  const banner = useSelector(getMortgageBanner);

  if (!banner?.image) {
    return null;
  }

  return (
    <Layout>
      <PromosWrapper controls={<ArrowControls navRef={navRef} />}>
        <PromoCarousel navRef={navRef}>
          {[<Banner key={0} image={banner.image} hitUrl={banner.hitUrl} disclaimer={banner.disclaimer} />]}
        </PromoCarousel>
      </PromosWrapper>
    </Layout>
  );
}
